import { SearchState } from '../types';

const registerFailedSearchRequestReducer = (state: SearchState) => {
  state.failedSearchRequestCount += 1;
};

export default registerFailedSearchRequestReducer;
